class Controller {
  constructor(
    $stateParams,
    Events,
    Sections,
    FinesReimbursementsTransforms,
    FineReimbursement
  ) {
    "ngInject";

    this.Events = Events;
    this.paginateEvent = Events.getPaginateEvent("finesReimbursements");
    this.filterEvent = Events.getFilterEvent("finesReimbursements");
    this.activeParams = $stateParams;
    this.sections = Sections.plansSections;
    this.FinesReimbursementsTransforms = FinesReimbursementsTransforms;
    this.FineReimbursement = FineReimbursement;

    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.FineReimbursement.getReasons().$promise.then(
      (response) => {
        const [, , reasonFilter] = this.FinesReimbursementsTransforms.filters;
        const reasonsOption = response.map(({ _id, title_i18n: { en } }) => ({
          name: _id,
          title: en,
          param: "reason",
        }));

        reasonFilter.listOptions = reasonsOption;
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/finesReimbursements/finesReimbursements.controller.js